import type { FC } from 'react';
import React from 'react';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import cn from 'classnames';

import type { ILabelProps } from '../models';

import styles from './styles.css';

export const Label: FC<ILabelProps> = ({ text }) => (
    <Text
        className={cn(styles.external, styles.ticker)}
        kind="secondary"
        styler={{ margin: 0, paddingBottom: 2, paddingTop: 2 }}
        tag="span"
        view="accent-secondary-small"
    >
        {text}
    </Text>
);
